import { render, staticRenderFns } from "./UserDetails_Section_Duels.vue?vue&type=template&id=ccc1c9f6&scoped=true&"
import script from "./UserDetails_Section_Duels.vue?vue&type=script&lang=js&"
export * from "./UserDetails_Section_Duels.vue?vue&type=script&lang=js&"
import style0 from "./UserDetails_Section_Duels.vue?vue&type=style&index=0&id=ccc1c9f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc1c9f6",
  null
  
)

export default component.exports